export default {
  attachmentPreviewLabel: 'sent attachment preview',
};
